export const PRICE_FILTERS = [
  {label: '$0-49', value: '0-4999'},
  {label: '$50-99', value: '5000-9999'},
  {label: '$100-149', value: '10000-14999'},
  {label: '$150+', value: '15000-*'},
];

export const POPULAR_GIFTS_PRICE_FILTER_OPTIONS = [
  {
    key: '%2A_49.99',
    values: {
      min: 0,
      max: 49.99,
    },
  },
  {
    key: '50.00_99.99',
    values: {min: 50, max: 99.99},
  },
  {
    key: '100.00_149.99',
    values: {
      min: 100,
      max: 149.99,
    },
  },
  {
    key: '150.00_%2A',
    values: {
      min: 150,
      max: 0,
    },
  },
];

export const PRICE_FILTERS_TRACKING_LOOKUP = {
  '%2A_49.99': '$0-$49',
  '50.00_99.99': '$50-$99',
  '100.00_149.99': '$100-$149',
  '150.00_%2A': '$150+',
};

const getPriceFilterSortOrderByValue = value =>
  PRICE_FILTERS.findIndex(f => f.value === value);

export const comparePriceFilterValueSortOrder = (a, b) =>
  getPriceFilterSortOrderByValue(a) - getPriceFilterSortOrderByValue(b);

export const getPriceFilterByValue = value =>
  PRICE_FILTERS.find(f => f.value === value);

export const getPopularGiftsPriceRangeByPrice = price =>
  POPULAR_GIFTS_PRICE_FILTER_OPTIONS.find(
    ({values: {min, max}}) => price >= min && (max === 0 || price <= max),
  )?.key;
